import React from "react";
import _ from "lodash";

const TOOL_PAGES = [
  {
    name: "Reporting Status",
    path: "/healthcheck/reporting-status",
  },
  {
    name: "Batch Update",
    path: "/tools/batch-update-auto-pilot-config",
  },
  {
    name: "Console Ops Log",
    path: "/console/ops-log",
  },
];
const DEFAULT_VALUE = "Go to...";

class NavigateToOtherPages extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      goToPage: DEFAULT_VALUE,
    };

    this.handleChanged = this.handleChanged.bind(this);
  }

  handleChanged(e) {
    const path = e.target.value;
    if (path === DEFAULT_VALUE) {
      return;
    }

    window.open(`${window.location.origin}/#${path}`);
    // TODO
    // this.setState({});
  }

  render() {
    return (
      <>
        <select
          // defaultValue={DEFAULT_VALUE}
          value={DEFAULT_VALUE}
          onChange={this.handleChanged}
          className="text-sm px-2 text-gray-300 border border-blue-600 shadow bg-blue-900 hover:bg-blue-800 rounded"
        >
          <option value={DEFAULT_VALUE}>{DEFAULT_VALUE}</option>

          {TOOL_PAGES.map((p) => {
            return (
              <option key={p.name} value={p.path}>
                {p.name}
              </option>
            );
          })}

          {/* {options.map((option) => {
            return (
              <option key={option.value} value={option.value}>
                {option.name}
              </option>
            );
          })} */}
        </select>
        {/* <button
          type="button"
          className="flex items-center text-sm px-4 text-gray-300 border border-blue-600 shadow bg-blue-900 hover:bg-blue-800 rounded"
          onClick={this.handleGoToBatchUpdateTool}
        >
          <div className="mr-2">
            <FaTools></FaTools>
          </div>
          Batch Update
        </button> */}
      </>
    );
  }
}

export default NavigateToOtherPages;
